import { CognitoUserSession } from 'amazon-cognito-identity-js';
import { AuthModals } from './types';

export interface AuthState {
  isModalOpen: boolean;
  modalStep: AuthModals | null;
  modalHistory: AuthModals[];
  email: string | null;
  password: string | null;
  confirmPassword: string | null;
  messageCode: string;
  messageCodeError: string | null;
  isLoading: boolean;
  isUser: boolean;
  userName: string | null;
  userSurname: string | null;
  error: { email?: string; password?: string; confirmPassword?: string; general?: string } | null;
}

export interface User {
  userInfo: {
    id: string;
    username: string;
    email: string;
    createdAt: string;
    updatedAt: string;
    token?: string;
    roles?: string[];
    refreshtoken?: string;
  };
}

export enum AuthActionTypes {
  TOGGLE_MODAL = "TOGGLE_MODAL",
  CHANGE_MODAL = "CHANGE_MODAL",
  GO_BACK_MODAL = "GO_BACK_MODAL",

  SET_EMAIL = "SET_EMAIL",
  SET_PASSWORD = "SET_PASSWORD",
  SET_CONFIRM_PASSWORD = "SET_CONFIRM_PASSWORD",
  CHANGE_MESSAGE_CODE = "CHANGE_MESSAGE_CODE",
  SET_OTP_ERROR = "SET_OTP_ERROR",
  CLOSE_DROPDOWN = 'CLOSE_DROPDOWN',
  TOGGLE_DROPDOWN = 'TOGGLE_DROPDOWN',

  SIGN_UP = "SIGN_UP",
  SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS",
  SIGN_UP_FAILED = "SIGN_UP_FAILED",

  CONFIRM_CODE = "CONFIRM_CODE",
  CONFIRM_CODE_SUCCESS = "CONFIRM_CODE_SUCCESS",
  CONFIRM_CODE_FAILED = "CONFIRM_CODE_FAILED",

  SIGN_IN = "SIGN_IN",
  SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS",
  SIGN_IN_FAILED = "SIGN_IN_FAILED",

  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_FAILED = 'FORGOT_PASSWORD_FAILED',

  CONFIRM_PASSWORD = 'CONFIRM_PASSWORD',
  CONFIRM_PASSWORD_SUCCESS = 'CONFIRM_PASSWORD_SUCCESS',
  CONFIRM_PASSWORD_FAILED = 'CONFIRM_PASSWORD_FAILED',

  SIGN_OUT = 'SIGN_OUT',
  SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS',
  SIGN_OUT_FAILED = 'SIGN_OUT_FAILED',

  GET_SESSION = 'GET_SESSION',
  GET_SESSION_SUCCESS = 'GET_SESSION_SUCCESS',
  GET_SESSION_FAILED = 'GET_SESSION_FAILED',
}

export interface ToggleModalAction {
  type: AuthActionTypes.TOGGLE_MODAL;
  payload: boolean;
}
export interface ChangeModalAction {
  type: AuthActionTypes.CHANGE_MODAL;
  payload: AuthModals;
}
export interface GoBackModalAction {
  type: AuthActionTypes.GO_BACK_MODAL;
}
export interface SetEmailAction {
  type: AuthActionTypes.SET_EMAIL;
  payload: string;
}
export interface SetPasswordAction {
  type: AuthActionTypes.SET_PASSWORD;
  payload: string;
}
export interface SetConfirmPasswordAction {
  type: AuthActionTypes.SET_CONFIRM_PASSWORD;
  payload: string;
}
export interface ChangeMessageCodeAction {
  type: AuthActionTypes.CHANGE_MESSAGE_CODE;
  payload: string;
}
export interface SetOtpErrorAction {
  type: AuthActionTypes.SET_OTP_ERROR;
  payload: string | null;
}

export interface ToggleDropdownAction {
  type:AuthActionTypes.TOGGLE_DROPDOWN
}
export interface CloseDropDownAction {
  type: AuthActionTypes.CLOSE_DROPDOWN
}

export interface SignUpAction {
  type: AuthActionTypes.SIGN_UP;
  email: string;
  password: string;
}
export interface SignUpSuccessAction {
  type: AuthActionTypes.SIGN_UP_SUCCESS;
  payload: any;
}
export interface SignUpFailedAction {
  type: AuthActionTypes.SIGN_UP_FAILED;
  error: string;
}
export interface ConfirmCodeAction {
  type: AuthActionTypes.CONFIRM_CODE;
  email: string;
  code: string;
}
export interface ConfirmCodeSuccessAction {
  type: AuthActionTypes.CONFIRM_CODE_SUCCESS;
  payload: any;
}
export interface ConfirmCodeFailedAction {
  type: AuthActionTypes.CONFIRM_CODE_FAILED;
  error: string;
}
export interface SignInAction {
  type: AuthActionTypes.SIGN_IN;
  email: string;
  password: string;
}
export interface SignInSuccessAction {
  type: AuthActionTypes.SIGN_IN_SUCCESS;
  payload: any;
}
export interface SignInFailedAction {
  type: AuthActionTypes.SIGN_IN_FAILED;
  error: string;
}
export interface ForgotPasswordAction {
  type: AuthActionTypes.FORGOT_PASSWORD;
  email: string;
}
export interface ForgotPasswordSuccessAction {
  type: AuthActionTypes.FORGOT_PASSWORD_SUCCESS;
  payload: any;
}
export interface ForgotPasswordFailedAction {
  type: AuthActionTypes.FORGOT_PASSWORD_FAILED;
  error: string;
}
export interface ConfirmPasswordAction {
  type: AuthActionTypes.CONFIRM_PASSWORD;
  email: string;
  password: string;
  code: string;
}
export interface ConfirmPasswordSuccessAction {
  type: AuthActionTypes.CONFIRM_PASSWORD_SUCCESS;
  payload: any;
}
export interface ConfirmPasswordFailedAction {
  type: AuthActionTypes.CONFIRM_PASSWORD_FAILED;
  error: string;
}
export interface SignOutAction {
  type: AuthActionTypes.SIGN_OUT;
}
export interface SignOutSuccessAction {
  type: AuthActionTypes.SIGN_OUT_SUCCESS;
}
export interface SignOutFailedAction {
  type: AuthActionTypes.SIGN_OUT_FAILED;
  error: string;
}
export interface GetSessionAction {
  type: AuthActionTypes.GET_SESSION;
}
export interface GetSessionSuccessAction {
  type: AuthActionTypes.GET_SESSION_SUCCESS;
  payload: { email: string; session: CognitoUserSession };
}
export interface GetSessionFailedAction {
  type: AuthActionTypes.GET_SESSION_FAILED;
  error: string;
}

export type AuthActions =
  | ToggleModalAction
  | ChangeModalAction
  | GoBackModalAction
  | SetEmailAction
  | SetPasswordAction
  | SetConfirmPasswordAction
  | ChangeMessageCodeAction
  | SetOtpErrorAction
  | CloseDropDownAction
  | ToggleDropdownAction
  | SignUpAction
  | SignUpSuccessAction
  | SignUpFailedAction
  | ConfirmCodeAction
  | ConfirmCodeSuccessAction
  | ConfirmCodeFailedAction
  | SignInAction
  | SignInSuccessAction
  | SignInFailedAction
  | ForgotPasswordAction
  | ForgotPasswordSuccessAction
  | ForgotPasswordFailedAction
  | ConfirmPasswordAction
  | ConfirmPasswordSuccessAction
  | ConfirmPasswordFailedAction
  | SignOutAction
  | SignOutSuccessAction
  | SignOutFailedAction
  | GetSessionAction
  | GetSessionSuccessAction
  | GetSessionFailedAction;

export const toggleModalAction = (payload: boolean) => ({
  type: AuthActionTypes.TOGGLE_MODAL,
  payload,
});

export const changeModalAction = (payload: AuthModals) => ({
  type: AuthActionTypes.CHANGE_MODAL,
  payload,
});

export const goBackModalAction = () => ({
  type: AuthActionTypes.GO_BACK_MODAL,
});

export const setEmailAction = (payload: string) => ({
  type: AuthActionTypes.SET_EMAIL,
  payload,
});

export const setPasswordAction = (payload: string) => ({
  type: AuthActionTypes.SET_PASSWORD,
  payload,
});

export const setConfirmPasswordAction = (payload: string) => ({
  type: AuthActionTypes.SET_CONFIRM_PASSWORD,
  payload,
});

export const changeMessageCodeAction = (payload: string) => ({
  type: AuthActionTypes.CHANGE_MESSAGE_CODE,
  payload,
});

export const setOtpAction = (payload: string | null) => ({
  type: AuthActionTypes.SET_OTP_ERROR,
  payload,
});

export const closeDropDownAction = () => ({
  type: AuthActionTypes.CLOSE_DROPDOWN,
});

export const toggleDropdownAction = () => ({
  type: AuthActionTypes.TOGGLE_DROPDOWN,
});

export const signUpAction = (email: string, password: string) => ({
  type: AuthActionTypes.SIGN_UP,
  email,
  password,
});

export const signUpSuccess = (payload: any) => ({
  type: AuthActionTypes.SIGN_UP_SUCCESS,
  payload,
});

export const signUpFailed = (error: string) => ({
  type: AuthActionTypes.SIGN_UP_FAILED,
  error,
});

export const confirmCode = (email: string, code: string) => ({
  type: AuthActionTypes.CONFIRM_CODE,
  email,
  code,
});

export const confirmCodeSuccess = (payload: any) => ({
  type: AuthActionTypes.CONFIRM_CODE_SUCCESS,
  payload,
});

export const confirmCodeFailed = (error: string) => ({
  type: AuthActionTypes.CONFIRM_CODE_FAILED,
  error,
});

export const signIn = (email: string, password: string) => ({
  type: AuthActionTypes.SIGN_IN,
  email,
  password,
});

export const signInSuccess = (payload: any) => ({
  type: AuthActionTypes.SIGN_IN_SUCCESS,
  payload,
});

export const signInFailed = (error: string) => ({
  type: AuthActionTypes.SIGN_IN_FAILED,
  error,
});

export const forgotPassword = (email: string) => ({
  type: AuthActionTypes.FORGOT_PASSWORD,
  email,
});

export const forgotPasswordSuccess = (payload: any) => ({
  type: AuthActionTypes.FORGOT_PASSWORD_SUCCESS,
  payload,
});

export const forgotPasswordFailed = (error: string) => ({
  type: AuthActionTypes.FORGOT_PASSWORD_FAILED,
  error,
});

export const confirmPassword = (email: string, code: string, password: string) => ({
  type: AuthActionTypes.CONFIRM_PASSWORD,
  email,
  code,
  password,
});

export const confirmPasswordSuccess = (paylaod: any) => ({
  type: AuthActionTypes.CONFIRM_PASSWORD_SUCCESS,
  paylaod,
});

export const confirmPasswordFailed = (error: string) => ({
  type: AuthActionTypes.CONFIRM_PASSWORD_FAILED,
  error,
});

export const signOut = () => ({
  type: AuthActionTypes.SIGN_OUT,
});

export const signOutSuccess = () => ({
  type: AuthActionTypes.SIGN_OUT_SUCCESS,
});

export const signOutFailed = (error: string) => ({
  type: AuthActionTypes.SIGN_OUT_FAILED,
  error,
});

export const getSession = () => ({
  type: AuthActionTypes.GET_SESSION,
});

export const getSessionSuccess = (payload: { email: string; session: CognitoUserSession}) => ({
  type: AuthActionTypes.GET_SESSION_SUCCESS,
  payload,
});

export const getSessionFailed = (error: string) => ({
  type: AuthActionTypes.GET_SESSION_FAILED,
  error,
});